// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3KNgN","itemA":"Write_itemA__WPuWA","itemB":"Write_itemB__1GTmc","itemC":"Write_itemC__3xPTd","itemD":"Write_itemD__1kNhH"};